import { checkIsTransparentColor } from '@/utils/color-kit';
import { pointScale, rotatePoint } from '@/utils/math-kit';
import { IBackgroundLayerProps, IImageLayerProps, ILayerProps, IMainLayerScope, IPoint } from '@/version-types';

/**
 * 将鼠标坐标点转化为主图的坐标点
 * @param mainLayer - 主图层
 * @param mousePoints - 鼠标坐标点
 */
export function convertMousePointToLayerPoint(mainLayer: ILayerProps, point: IPoint) {
    const { left, top, rotate, data } = mainLayer;
    const { naturalWidth, naturalHeight, imageTransform } = data as IImageLayerProps;
    const { scale, flipH, flipV } = imageTransform;

    // 旋转的时候需要先转换为笛卡尔坐标系，DOM 里面的坐标系 y 是向下的
    const newPoint = rotatePoint(
        {
            x: point.x - left - (naturalWidth * scale) / 2,
            y: -(point.y - top - (naturalHeight * scale) / 2),
        },
        rotate,
    );

    // 再转换为 DOM 的坐标系
    newPoint.y = -newPoint.y;

    if (flipV) {
        newPoint.y = -newPoint.y;
    }

    if (flipH) {
        newPoint.x = -newPoint.x;
    }

    return pointScale(
        {
            x: newPoint.x + (naturalWidth * scale) / 2,
            y: newPoint.y + (naturalHeight * scale) / 2,
        },
        1,
    );
}

/**
 * 检查当前主图操作是否是否需要合并所有图层
 * @param scope 当前操作作用范围
 * @param layers 画布中的所有图层
 * @returns 是否需要合并图层
 */
export function checkNeedMergeCanvas(scope: IMainLayerScope | undefined, layers: ILayerProps[]) {
    if (scope !== 'canvas') return false;

    // TODO: @cxz1 检查图片是否带有透明度
    // 如果有背景，则需要合并为一张图片进行处理
    const backgroundLayerData = layers.find((layer) => layer.layerType === 'bg')?.data as
        | IBackgroundLayerProps
        | undefined;
    const hasBackground =
        (backgroundLayerData?.backgroundColor && !checkIsTransparentColor(backgroundLayerData.backgroundColor)) ||
        backgroundLayerData?.backgroundGradient ||
        backgroundLayerData?.url;

    if (hasBackground) return true;

    // 如果有其它图层，则需要合并为一张图片进行处理
    const extraLayers = layers.filter((layer) => ['bg', 'mainImg'].indexOf(layer.layerType) === -1);
    const hasExtraLayer = extraLayers.length > 0;

    return hasExtraLayer;
}
